// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GsC_KPQmqatGgFWxzAIw {
    line-height: 1.25;
}

.GsC_KPQmqatGgFWxzAIw img {
    width: 100%;
}

.GsC_KPQmqatGgFWxzAIw table {
    width: 100%;
    line-height: 1.5;
    margin-bottom: 1em;
}

.GsC_KPQmqatGgFWxzAIw table td,
.GsC_KPQmqatGgFWxzAIw table th {
    border-bottom: 1px solid #ccc;
    padding: 4px 0;
}

.GsC_KPQmqatGgFWxzAIw ul,
.GsC_KPQmqatGgFWxzAIw ol {
    padding-left: 1.3em;
}

.GsC_KPQmqatGgFWxzAIw li + li {
    margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/eligibility/components/fields/markdown.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;IAEI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".markdown {\n    line-height: 1.25;\n}\n\n.markdown img {\n    width: 100%;\n}\n\n.markdown table {\n    width: 100%;\n    line-height: 1.5;\n    margin-bottom: 1em;\n}\n\n.markdown table td,\n.markdown table th {\n    border-bottom: 1px solid #ccc;\n    padding: 4px 0;\n}\n\n.markdown ul,\n.markdown ol {\n    padding-left: 1.3em;\n}\n\n.markdown li + li {\n    margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"markdown": `GsC_KPQmqatGgFWxzAIw`
};
export default ___CSS_LOADER_EXPORT___;
